import Vue from 'vue'
import Vuex from 'vuex'

import globals from './modules/globals'
import localSettings from './modules/localSettings'
import h24 from './modules/h24'
import settings from './modules/settings'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    globals,
    localSettings,
    h24,
    settings
  }
})
